import {
  Grid,
  GridCell,
  Spacer,
  TextSubtitle,
} from '@pypestream/design-system';
import React, { FC, KeyboardEvent, PropsWithChildren, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ToolModal } from '..';
import {
  useManagerCtxSelector,
  useManagerStateMatchesOneOf,
} from '../../xstate/app.xstate';
import { ProductCTA } from '../product-cta';
import './page-header.scss';
import { TranslationComponent } from '@pypestream/translations';

export const PageHeader: FC<PropsWithChildren> = () => {
  const navigate = useNavigate();
  const [selectedTool, setSelectedTool] = useState<string | undefined>();
  const { tools } = useManagerCtxSelector((ctx) => ({
    tools: ctx.tools,
  }));

  const shouldWaitDataLoad = !!useManagerStateMatchesOneOf([
    'orgRelated.ready.projectsNew.loading',
  ]);

  return (
    <>
      <TextSubtitle>
        <TranslationComponent i18nKey="manager/common:homepage.header.tools">
          Tools
        </TranslationComponent>
      </TextSubtitle>
      <Spacer size="small" />
      <Grid gutter="small">
        {tools.map((tool) => {
          const { logo, label, productId, url, disabled, conditional, name } =
            tool;

          console.log('tool', tool);

          const clickAction = conditional
            ? {
                ...(url
                  ? { url }
                  : {
                      onClick: () => setSelectedTool(productId),
                      onKeyDown: (e: KeyboardEvent) => {
                        if (e.key === 'Enter') setSelectedTool(productId);
                      },
                    }),
              }
            : {
                ...(url && url.includes('https')
                  ? { url }
                  : {
                      onClick: () => {
                        if (url) navigate(url);
                      },
                      onKeyDown: (e: KeyboardEvent) => {
                        if (url && e.key === 'Enter') navigate(url);
                      },
                    }),
              };

          return (
            <GridCell key={label} xsmall="12" small="6" medium="3">
              <ProductCTA
                test-id={`product-cta-${label?.replace(' ', '-').toLowerCase()}`}
                logo={logo}
                name={label}
                disabled={disabled || shouldWaitDataLoad}
                productName={name}
                width="full"
                {...clickAction}
              />
            </GridCell>
          );
        })}
      </Grid>
      <Spacer size="large" />
      <ToolModal
        open={!!selectedTool}
        tools={tools}
        selectedTool={selectedTool}
        onClose={() => setSelectedTool(undefined)}
      />
    </>
  );
};
